import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DealRoom } from 'models/DealRoom';
import useQueryParams from 'hooks/useQueryParams';
import SearchEmptyState from '../SearchEmptyState';
import RecentActivityPanel from '../RecentActivityPanel';

import './SearchNoResults.styles.scss';

type SearchNoResultsProps = {
  className?: string;
  searchString: string;
  recentSearches: string[];
  recentlyViewedDeals: DealRoom[];
};

const SearchNoResults: FC<SearchNoResultsProps> = (props) => {
  const { className, searchString, recentSearches, recentlyViewedDeals } =
    props;

  const { removeQueryParam } = useQueryParams();

  const { t } = useTranslation();

  const classes = classNames('search-no-results', className);

  return (
    <div className={classes}>
      <SearchEmptyState
        className="white-panel"
        title={t('noResultsFoundForSearchTitle', { searchString })}
        description={t('noResultsFoundForSearchDescription')}
        action={{
          label: t('clearSearch'),
          onClick: () => removeQueryParam('searchString'),
        }}
      />

      <RecentActivityPanel
        recentSearches={recentSearches}
        recentlyViewedDeals={recentlyViewedDeals}
      />
    </div>
  );
};

export default SearchNoResults;
